import { ResultCardProps } from "./types/result-card.types";

export const ResultCard = ({ title, image, subtitle, onClick }: ResultCardProps) => {
  return (
    <div
      onClick={onClick}
      className="
        w-full min-h-[110px] flex flex-col items-center justify-between gap-0.5
        rounded-xl border border-[#e9eaeb] bg-white px-1 py-3 shadow-[0px_1px_2px_rgba(10,13,18,0.05)]
        hover:bg-[#F0FAF9] hover:border-[#C6F0E9] hover:shadow-[0px_4px_4px_rgba(42,128,123,0.25)]
        cursor-pointer transition-all duration-200
      "
    >
      <div className="h-[16px] flex items-center justify-center w-full pt-1">
        <span className="text-[10px] leading-[24px] text-[#2e2e2e] text-center font-semibold">{title}</span>
      </div>
      <div className="w-full h-full flex-1 flex items-center justify-center py-1">
        <img src={image} alt={title} className="w-[70px] h-[55px] object-contain" />
      </div>
      <div className="w-full flex items-center justify-center pb-1">
        <span className="text-[11px] leading-[18px] text-[#2a807b] text-center font-semibold">{subtitle}</span>
      </div>
    </div>
  );
};
